export default {
  custom_allergen: {
    placeholder: 'Tilføj brugerdefineret valg',
  },
  buttons: {
    add: 'Tilføj',
  },
};
